export const DEERFLOW_THREADS_REQUEST_OBJECT = {
  limit: 50,
  offset: 0,
  sort_by: "updated_at",
  sort_order: "desc",
  select: ["thread_id", "updated_at", "values", "metadata"],
};
